
		<div
			class="text-center loader"
			*ngIf="isLoad"
			[sextant]="'loader'"
		>
			<img src="/img/loader.svg" class="img-responsive">
		</div>
	